module.exports = __webpack_public_path__ + "static/media/red_bull.40ee0a2e.jpg";